import {constructBidShares, constructMediaData, sha256FromBuffer, generateMetadata, isMediaDataVerified, Zora } from '@zoralabs/zdk';
import Sequence from 'repos/Sequence.js';
import accounts from "accounts/Accounts.js";
import {ipfsHashToBytes32} from 'utils/ipfsHash';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {ZPROJECTS} from 'decentralized/transactions/contracts.js';
import {
    setShowLogin,
    setTransactionUponLogin,
    setNewZoraTokenId,
    setMintingProgress} from 'actions/index.js';
import ethereum from 'decentralized/ethereum.js';
import {ethers} from 'ethers';
import {str2ab} from 'utils/ArrayBufferConverter.js';
import ipfs from 'decentralized/Ipfs.js';

const TIMEOUT = 12000;


const getAnimationContent = async (url) => {
    let resp = await fetch(url , {
        method: 'GET'
    });
    resp = await resp.arrayBuffer();
    return Buffer.from(resp);
};

export const getMetadata = async (data) => {
    // let content = Buffer.from(JSON.stringify(projectJson));
    //let contentURI = "http://zequencer.io:8080/ipfs/" + data.animationUrl;
    let contentURI = "https://zequencer.io/ipfs/" + data.animationUrl;
    let previewImageUrl = "https://zequencer.io/ipfs/QmUKVhbFgiGLhWay37Ek9Yo3tduHJrgeg9ekwLT5J2m7XR";
    return {
        description: "test descroption",
        mimeType: 'text/html',
        //image: previewImageUrl,
        animation_url: contentURI,
        name: "test",
        version: 'zora-20210604',
    };
};

export const mintToZora = (data, name, description, thumbnail, royalties, sequencerEngine) => {
    return new Promise(async (resolve, reject) => {
        let failed = false;
        let sentTransaction = false;
        let confirmedTransaction = false;

        setTimeout(() => {
            if (!sentTransaction) {
                failed = true;
                console.log("FAILED!");
                reject("timed out");
            }
        }, TIMEOUT);

        let contentURI = "https://zequencer.io/ipfs/" + data.animationUrl + '/';
        let {projectJson} = data;
        let content = await getAnimationContent(
            "https://zequencer.io/ipfs/" + data.animationUrl);

        let previewImageUrl = "https://zequencer.io/ipfs/" + thumbnail;
        const metadataJSON = generateMetadata('zora-20210604', {
            description: description,
            mimeType: 'text/html',
            image: previewImageUrl,
            animation_url: contentURI, // its one in the same
            name: name,
            version: 'zora-20210604',
        });
        
        let metadataURI = await ipfs.addBuffer(Buffer.from(metadataJSON));

        // need to point to ipfsJSON to force content-type: application/json
        // how does ipfs.io work? it seems to correctly detect the content-type
        // whhile my gateway does not :(
        metadataURI = "https://zequencer.io/ipfsJSON/" + metadataURI;

        const contentHash = sha256FromBuffer(content);
        const metadataHash = sha256FromBuffer(Buffer.from(metadataJSON));
        
        const mediaData = constructMediaData(
            contentURI,
            metadataURI,
            contentHash,
            metadataHash
        );
        
        console.log('media data = ', mediaData);
        const verified = await isMediaDataVerified(mediaData, 10000);
        if (!verified){
            throw new Error("MediaData not valid, do not mint");
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        // Prompt user for account connections
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        let chainId = 4;
        let zora = new Zora(signer, chainId);
        
        // BidShares should sum up to 100%
        const bidShares = constructBidShares(
            royalties, // creator share percentage
            100-royalties, // owner share percentage
            0 // prevOwner share percentage (not used for now)
        );
        
        sequencerEngine.dispatch(
            setMintingProgress("Confirm your transaction in your wallet"));

        sequencerEngine.dispatch(
            setNewZoraTokenId(undefined));

        sentTransaction = true;
        if (failed) {
            return;
        }

        try {
            const tx = await zora.mint(mediaData, bidShares);
            
            // This listens for the nft transfer event
            sequencerEngine.dispatch(
                setMintingProgress("Now wait a little, your transaction is being processed."));
            zora.media.on(
                "Transfer",
                (from, to, tokenId) => {
                    confirmedTransaction = true;
                    window.localStorage.setItem("new_zora_token", JSON.stringify({
                        zoraId: tokenId.toNumber(),
                        projectHash: sequencerEngine.sequenceId
                    }));
                    sequencerEngine.dispatch(
                        setNewZoraTokenId(tokenId.toNumber()));
                    saveTokenId(tokenId.toNumber(), sequencerEngine.sequenceId, sequencerEngine, name);
                    resolve();
                });
        } catch (e) {
            console.log("error while mintingg", e);
            reject("rejected");
        }
    });
};

const saveTokenId = (tokenId, projectHash, sequencerEngine, title) => {
    return new Promise(async (resolve, reject) => {
        let transaction = new EthereumTransaction(
            ZPROJECTS, 'zoraProject',
            [ipfsHashToBytes32(projectHash), tokenId]);
 
        if (!accounts.isLoggedIn() || (
            accounts.isLoggedIn() && !(await accounts.checkLogin()))) {
            // user was logged out (theres a dumb iframe issue where
            // for some reason we get logged out)

            // in this case we ask them to login again
            sequencerEngine.dispatch(
                setTransactionUponLogin(transaction));
            sequencerEngine.dispatch(
                setShowLogin(true));
            setTimeout(() => {
                ethereum.saveNewSequence(undefined, projectHash, title, sequencerEngine.getSamples(), sequencerEngine.bpm);
            }, 5000);
        } else { 
            transaction.execute()
                .then(transactionHash => resolve)
                .catch(err => reject);

            ethereum.saveNewSequence(undefined, projectHash, title, sequencerEngine.getSamples(), sequencerEngine.bpm);

        }
    });
};
